module.exports = __webpack_public_path__ + "img/djooky-talks.24ab0897.svg";